(function($) {
	// bind the event to the production filter buttons 
	$('.filters-production .btn').bind('click', function(e) {
		e.preventDefault();

		const id = $(this).attr('id');

        if($(this).hasClass('is-active')) {
           $(this).removeClass('is-active');
           barProductionFilter('*');
        }
        else {
            $(this).addClass('is-active');
            $(this).parent('li').siblings().find('.btn').removeClass('is-active');
            barProductionFilter(id);
        }
        
	});

    function barProductionFilter(id){
        $('.bar-production .bar-production__values, .bar-production .bar-production__scores').each(function(){
            const $this = $(this);

            switch(true) {
                case id === '*':
                    $this.show().removeClass('is-visible');
                break;
                case $this.hasClass(id):
                    $this.show().addClass('is-visible');
                break;
                default:
                    $this.hide().removeClass('is-visible');
            }
        });
    }

    // Use list.js to sort the producer countries matrix table
	if($('#matrix-producer-countries .matrix__table').length > 0) {
		var options = {
			valueNames: [ 'cahra-value', 'airs-value', 'conflict-value', 'law-value', 'human-rights-value', 'environment-value' ]
		};
	  
		var matrixList = new List('matrix-producer-countries', options);
	}

    // Tooltip show/hide function for the issues table
	$('.issues__area.has-tooltip').hover(function(e) {
		e.preventDefault();
		$(this).find('.tooltip').stop().fadeIn(250);
	})
	.mouseleave(function () {
		$(this).find('.tooltip').stop().fadeOut(250);
	});

})( jQuery );